<template>
  <div class="user-view" />
</template>

<script>
import isUserRole from "@/help/isUserRole";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Verify",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile/profile"
    }),

    isIssuer() {
      return isUserRole() === "issuer";
    }
  },
  async created() {
    if (this.$auth.check()) {
      await this.getProfileWihtoutLoading(this.$auth.user().id);
    }
    this.checkEmail();
  },
  methods: {
    ...mapActions({
      emailVerify: "emailVerify",
      getProfileWihtoutLoading: "profile/getProfileWihtoutLoading"
    }),

    goToLogin() {
      if (this.$auth.check()) {
        this.$router.push({ name: this.isIssuer ? "dashboard" : "projects" });
      }
      else {
        this.$router.push({ name: "login" });
      }
    },

    async checkEmail() {
      const hash = this.$route.params.hash;

      const params = {
        token: `${hash}`
      };
      try {
        const resp = await this.emailVerify(params);
        if (resp.status == 267) {
          this.$store.dispatch("setIsTokenVerify", "error");
        }
        if (resp.status == 204) {
          this.$store.dispatch("setIsTokenVerify", "success");
        }
      }
      catch (error) {
        this.$store.dispatch("setIsTokenVerify", "error");
        console.log("error", error.response);
      }
      this.goToLogin();
    }
  }
};
</script>

<style scoped lang="scss">
.user-view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--main-color);
  height: 100vh;
  width: 100vw;
}
</style>
